import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted } from 'vue';
import { useTranslate } from '@/composables/use-globals';
import { EventBus } from '@/services/event-bus';
import { db } from '@/services/db';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenanceMode',
  props: {
  checkOnline: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const translate = useTranslate();

onMounted(() => {
  if (props.checkOnline) {
    EventBus.$on('check-online-status', async () => {
      db.checkIsOnline();
    });
  }
});

onUnmounted(() => {
  if (props.checkOnline) {
    EventBus.$off('check-online-status');
  }
});

return { __sfc: true,props, translate }
}

})